import React from 'react'
import Breadcrub from '../Common/Breadcrub'

const ExaminationCell = () => {
  return (
    <>
      <Breadcrub title="Examination Cell"  />
        <section class="aboutus-style-01">
            <div class="container">
                <div class="row align-items-center">
                    <div class="col-xl-12">                        
                        <h2>Sessional Examinations</h2>                   
                        <p>There shall be two or more periodic sessional (internal assessment) examinations during each academic year. The duration of the sessional exam shall be 90 minutes. The highest aggregate of any two performances shall form the basis of calculating the sessional marks. The scheme of the question paper for theory sessional examinations shall be as given below.</p>       
                        <ul className='roman-number'>
                            <li>Long Answers (Answer 3 out of 4) 3 x 5 = 15</li>
                            <li>Short Answers (Answer 5 out of 6) 5 x 3 = 15</li>
                            <li>Objective type Answers (Answer all 10 out of 10) 10 x 1 =10</li>
                            <li>(Multiple Choice Questions / Fill-in the Blanks / One word OR one Sentence questions)</li>
                            <li>Total = 40 marks</li>
                        </ul>
                        <h3>Internal assessment</h3>   
                        <p>The marks secured by the students out of the total 40 shall be reduced to 20 in each sessional, and then the internal assessment shall be calculated based on the best two averages for 20 marks.</p>
                        <h3>Final Board / University Examinations</h3>
                        <p>The scheme of the question paper for the theory examinations conducted by the examining authority (Board / University) shall be as given below. The duration of the final examination shall be 3 hours.</p>
                        <ul className='roman-number'>
                            <li>Long Answers (Answer 6 out of 7) = 6 x 5 = 30</li>
                            <li>Short Answers (Answer 10 out of 11) = 10 x 3 = 30</li>
                            <li>Objective type Answers (Answer all 20) = 20 x 1 = 20 (Multiple Choice Questions / Fill-in the Blanks / One word OR one Sentence questions)</li>
                            <li>Total = 80 marks</li>
                        </ul>

                        <h3>Sessional Examinations</h3>   
                        <p>There shall be two or more periodic sessional (internal assessment) practical examinations during each academic year. The duration of the sessional exam shall be three hours. The highest aggregate of any two performances shall form the basis of calculating the sessional marks. The scheme of the question paper for practical sessional examinations shall be as given below.</p>
                        <ul className='roman-number'>
                            <li>Synopsis = 10</li>
                            <li>Experiments = 50*</li>
                            <li>Viva voce = 10</li>
                            <li>Practical Record Maintenance = 10</li>
                            <li>Total = 80 marks</li>
                        </ul>

                        <p>* The marks for the experiments shall be divided into various categories, viz. major experiment, minor experiment, spotters, etc. as per the requirement of the course.</p>
                        <h3>Internal assessment</h3>   
                        <p>The marks secured by the students out of the total of 80 shall be reduced to 10 in each sessional, and then the internal assessment shall be calculated based on the best two averages for 10 marks from the sessional and other 10 marks shall be awarded as per the details given below.</p>
                        <ul className='roman-number'>
                            <li>Actual performance in the sessional examination = 10 marks</li>
                            <li>Assignment marks (Average of three) = 5 marks*</li>
                            <li>Field Visit Report marks (Average for the reports) = 5 marks$</li>
                            <li>Total = 20 marks</li>
                        </ul>
                        <p>*, $ Only for the courses given with both assignments and field visit/s</p>
                        <h3>Note</h3>   
                        <ul className='roman-number'>
                            <li>For the courses having either assignments or field visit/s, the assessments of assignments or field visit/s shall be done directly for 10 marks and added to the sessional marks.</li>
                            <li>For the courses not having both assignment and field visit, the whole 20 marks shall be calculated from the sessional marks. </li>
                        </ul>
                        <h3>Final Board / University Examinations</h3>   
                        <p>The scheme of the question paper for the practical examinations conducted by the examining authority (Board / University) shall be as given below. The duration of the final examination shall be 3 hours.</p>
                        <ul className='roman-number'>
                            <li>Synopsis = 10</li>
                            <li>Experiments = 60*</li>
                            <li>Viva voce = 10</li>
                            <li>Total = 80 marks</li>
                        </ul>
                        <p>* The marks for the experiments shall be divided into various categories, viz. major experiment, minor experiment, spotters, etc. as per the requirement of the course. </p>
                    </div>
                </div>
            </div>
        </section>
    </>
  )
}

export default ExaminationCell
